import React, { useEffect, useState } from "react";
import Image from "next/image";
import LazySection from "../../../components/LazySection";
import TarotTables from "./TarotTables";

export default function Common_html({ BlockData }) {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(
        typeof window !== "undefined" ? window.innerWidth > 1199 : false
      );
    };

    handleResize();

    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  return (
    <>
      <div
        className={`common_leftright_pattern_block_mainwrapper ${BlockData.chapter_class}`}
      >
        {BlockData.blocks.map((block, index) => (
          <LazySection key={index} className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              {block.has_heading && (
                <div className="common_leftright_pattern_titleblock">
                  <div className="common_leftright_pattern_titleblock_commonwidth">
                    <span className="common_leftright_pattern_titleblock_inner">
                      <div className="common_leftright_pattern_titleblock_header_wrapper">
                        <h1
                          className="common_leftright_pattern_titleblock_header"
                          dangerouslySetInnerHTML={{
                            __html: block.heading_text,
                          }}
                        ></h1>
                      </div>
                    </span>
                  </div>
                </div>
              )}

              <div
                className={`common_leftright_pattern_block centraldoctrine_leftright_pattern_block${
                  index + 1
                }`}
              >
                <div className="common_leftright_pattern_content_commonwidth">
                  {(() => {
                    const renderContent = (contentItems) => {
                      let renderedElements = [];
                      let paragraphGroup = [];

                      contentItems.forEach((item, itemIndex) => {
                        if (item.type === "paragraph") {
                          paragraphGroup.push(
                            <p
                              className="common_leftright_pattern_block_paragraph"
                              dangerouslySetInnerHTML={{ __html: item.text }}
                              key={`paragraph-${itemIndex}`}
                            ></p>
                          );
                        } else {
                          if (paragraphGroup.length > 0) {
                            renderedElements.push(
                              <div
                                className="common_leftright_pattern_block_paragraph_wrapper"
                                key={`paragraph-group-${renderedElements.length}`}
                              >
                                {paragraphGroup}
                              </div>
                            );
                            paragraphGroup = [];
                          }
                          switch (item.type) {
                            case "quote":
                              renderedElements.push(
                                <div
                                  className="common_leftright_pattern_block_quotation_wrapper"
                                  key={`quote-${itemIndex}`}
                                >
                                  <p
                                    className="common_leftright_pattern_block_quotation"
                                    dangerouslySetInnerHTML={{
                                      __html: item.text,
                                    }}
                                  ></p>
                                  <p
                                    className="common_leftright_pattern_block_quotation_owner"
                                    dangerouslySetInnerHTML={{
                                      __html: item.author,
                                    }}
                                  ></p>
                                </div>
                              );
                              break;
                            case "inside_block_datalist":
                              renderedElements.push(
                                <div
                                  className="common_leftright_pattern_inside_block_datalist_wrapper"
                                  key={`datalist-${itemIndex}`}
                                >
                                  <div className="common_leftright_pattern_inside_block_datalist_innerwrapper">
                                    {item.text && (
                                      <h3
                                        className="common_leftright_pattern_inside_block_datalist_title"
                                        dangerouslySetInnerHTML={{
                                          __html: item.text,
                                        }}
                                      ></h3>
                                    )}
                                    <div className="common_leftright_pattern_inside_block_datalist_content">
                                      {item.list_items &&
                                        Array.isArray(item.list_items) &&
                                        item.list_items.map(
                                          (listItem, listIndex) => (
                                            <p
                                              className="common_leftright_pattern_inside_block_datalist_data"
                                              key={`datalist-item-${listIndex}`}
                                            >
                                              <strong>{listItem.key}:</strong>{" "}
                                              {listItem.value}
                                            </p>
                                          )
                                        )}
                                    </div>
                                  </div>
                                </div>
                              );
                              break;
                            case "inside_block_yellow_square_bulletpoint_datalist":
                              renderedElements.push(
                                <div
                                  className="common_leftright_pattern_inside_block_yellow_square_bulletpoint_datalist_wrapper"
                                  key={`yellow_square_bulletpoint_datalist-${itemIndex}`}
                                >
                                  <ul
                                    className={`common_leftright_pattern_inside_block_yellow_square_bulletpoint_datalist_content ${item.column_count}`}
                                    
                                  >
                                    {item.list_items &&
                                      Array.isArray(item.list_items) &&
                                      item.list_items.map(
                                        (listItem, listIndex) => (
                                          <li
                                            className="common_leftright_pattern_inside_block_yellow_square_bulletpoint_datalist_data"
                                            key={`yellow_square_bulletpoint_datalist-item-${listIndex}`}  dangerouslySetInnerHTML={{ __html: listItem.text }}
                                          >
                                           
                                          </li>
                                        )
                                      )}
                                  </ul>
                                </div>
                              );
                              break;
                            default:
                              break;
                          }
                        }
                      });

                      if (paragraphGroup.length > 0) {
                        renderedElements.push(
                          <div
                            className="common_leftright_pattern_block_paragraph_wrapper"
                            key={`paragraph-group-final`}
                          >
                            {paragraphGroup}
                          </div>
                        );
                      }
                      return renderedElements;
                    };

                    let imageUrl = "";
                    if (
                      block.type == "position_bothsides" ||
                      block.type == "tableblock_position_bothsides" ||
                      block.type == "cardgrid_insideblock"
                    ) {
                      imageUrl = isDesktop
                        ? block.block_positioned_image_url_desktop
                        : block.block_positioned_image_url_mobile;
                    }

                    switch (block.type) {
                      case "position_bothsides":
                        return (
                          <div
                            className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_${
                              index % 2 === 0 ? "left" : "right"
                            }`}
                          >
                            {imageUrl &&
                              typeof imageUrl === "string" &&
                              imageUrl.length > 0 && (
                                <div className="common_leftright_pattern_block_position_image_wrapper">
                                  <Image
                                    className="next_image"
                                    src={imageUrl}
                                    alt="Block Content"
                                    width={1200}
                                    height={800}
                                  />
                                </div>
                              )}

                            {block.content && (
                              <div className="common_leftright_pattern_block_content">
                                <div className="centraldoctrine_leftright_pattern_block_topborder"></div>

                                {renderContent(block.content)}
                              </div>
                            )}
                          </div>
                        );

                      case "flex_bothsides":
                        return (
                          <div
                            className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_flex_${
                              index % 2 === 0 ? "left" : "right"
                            }`}
                          >
                            {block.flex_image_url &&
                              typeof block.flex_image_url === "string" &&
                              block.flex_image_url.length > 0 && (
                                <div className="common_leftright_pattern_block_flex_image_wrapper">
                                  <Image
                                    className="next_image"
                                    src={block.flex_image_url}
                                    alt="Flex Image"
                                    width={1200}
                                    height={800}
                                  />
                                </div>
                              )}
                            {block.content && (
                              <div className="common_leftright_pattern_block_content">
                                <div className="centraldoctrine_leftright_pattern_block_topborder" />

                                {renderContent(block.content)}
                              </div>
                            )}
                          </div>
                        );

                      case "tableblock_position_bothsides":
                        return (
                          <div
                            className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_${
                              index % 2 === 0 ? "left" : "right"
                            }`}
                          >
                            {imageUrl &&
                              typeof imageUrl === "string" &&
                              imageUrl.length > 0 && (
                                <div className="common_leftright_pattern_block_position_image_wrapper">
                                  <Image
                                    className="next_image"
                                    src={imageUrl}
                                    alt="Block Content"
                                    width={1200}
                                    height={800}
                                  />
                                </div>
                              )}

                            {block.tableblock_content && (
                              <div className="common_leftright_pattern_block_content">
                                <div className="centraldoctrine_leftright_pattern_block_topborder"></div>

                                {block.has_tableblock_heading && (
                                  <h2 className="common_leftright_pattern_block_tabletypeblock_heading">
                                    {block.tableblock_heading_text}
                                  </h2>
                                )}
                                <div className="common_leftright_pattern_block_tabletypeblock_contentwrapper">
                                  {block.tableblock_content &&
                                    block.tableblock_content
                                      .tableblock_content_left.length > 0 && (
                                      <div className="common_leftright_pattern_block_tabletypeblock_content common_leftright_pattern_block_tabletypeblock_contentleft">
                                        {block.tableblock_content.tableblock_content_left.map(
                                          (item, idx) => (
                                            <p
                                              className="common_leftright_pattern_block_tabletypeblock_paragraph"
                                              key={idx}
                                              dangerouslySetInnerHTML={{
                                                __html: item.text,
                                              }}
                                            />
                                          )
                                        )}
                                      </div>
                                    )}
                                  {block.tableblock_content
                                    .tableblock_content_right &&
                                    block.tableblock_content
                                      .tableblock_content_right.length > 0 && (
                                      <div className="common_leftright_pattern_block_tabletypeblock_content common_leftright_pattern_block_tabletypeblock_contentright">
                                        {block.tableblock_content.tableblock_content_right.map(
                                          (item, idx) => (
                                            <p
                                              className="common_leftright_pattern_block_tabletypeblock_paragraph"
                                              key={idx}
                                              dangerouslySetInnerHTML={{
                                                __html: item.text,
                                              }}
                                            />
                                          )
                                        )}
                                      </div>
                                    )}
                                </div>
                              </div>
                            )}
                          </div>
                        );

                      case "cardgrid_insideblock":
                        return (
                          <div
                            className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_${
                              index % 2 === 0 ? "left" : "right"
                            }`}
                          >
                            {imageUrl &&
                              typeof imageUrl === "string" &&
                              imageUrl.length > 0 && (
                                <div className="common_leftright_pattern_block_position_image_wrapper">
                                  <Image
                                    className="next_image"
                                    src={imageUrl}
                                    alt="Block Content"
                                    width={1200}
                                    height={800}
                                  />
                                </div>
                              )}

                            <div className="common_leftright_pattern_block_content">
                              <div className="centraldoctrine_leftright_pattern_block_topborder"></div>

                              {block.content && renderContent(block.content)}

                              {block.cards && (
                                <div className="card_grid_wrapper">
                                  {block.cards.map((card, i) => (
                                    <div className="card_grid_item" key={i}>
                                      <div className="card_grid_title">
                                        {card.title}
                                      </div>
                                      <div className="card_grid_sect">
                                        <strong>Sect:</strong> {card.sect}
                                      </div>
                                      <div className="card_grid_date">
                                        <strong>Date:</strong> {card.date}
                                      </div>
                                      {card.description && (
                                        <div className="card_grid_description">
                                          {card.description}
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        );

                      case "table_with_tarrotcards":
                        return React.createElement(
    "div",
    { className: "common_leftright_pattern_block_inner_wrapper" },
    React.createElement(
      "div",
      { className: "common_leftright_pattern_block_content" },
      React.createElement("div", {
        className: "centraldoctrine_leftright_pattern_block_topborder",
      }),
      Array.isArray(block.table_content) && block.table_content.length > 0
        ? React.createElement(TarotTables, {
            tableContent: block.table_content,
          })
        : null
    )
  );

                      default:
                        return (
                          <div
                            className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_${
                              (index + 1) % 2 === 0 ? "left" : "right"
                            }`}
                          >
                            {block.content && (
                              <div className="common_leftright_pattern_block_content">
                                <div className="centraldoctrine_leftright_pattern_block_topborder" />

                                {renderContent(block.content)}
                              </div>
                            )}
                          </div>
                        );
                    }
                  })()}
                </div>
              </div>
            </div>
          </LazySection>
        ))}
      </div>
    </>
  );
}
